import {
  EHandbookMedia,
  EMsnMedia,
  Language,
  SlsMfa,
  SlsMfaOptionTypeEnum
} from '@cms-max/medicare-api-sdk'
import { IMedicareCard, BaseUser, UserWithFields, User } from 'models/User'

export const defaultMfaResponse: SlsMfa = {
  promptForMfaEnrollment: false,
  configuredOptions: [
    {
      id: '123',
      type: SlsMfaOptionTypeEnum.Email,
      mfaChannel: 's***t@h***.com',
      deactivated: false,
      deactivatedTimestamp: null,
      optedOut: false,
      optedOutTimestamp: null
    }
  ]
}

export const defaultBeneficiaryResponse: BaseUser = {
  mailingAddress: {
    zip: '02050',
    city: 'New York',
    state: 'NY',
    address1: '',
    address2: ''
  },
  firstName: 'Stephanie',
  lastName: 'Flintstone',
  middleName: 'C',
  railroadRetirementBoardBeneficiary: false,
  username: 'fredFlintstone',
  challenges: [
    {
      question: 'What is the name of the first street you lived on?'
    }
  ],
  mfa: defaultMfaResponse,
  hasPartA: true,
  hasPartB: true,
  isImmunosuppressiveDrugCoverage: false,
  isMedicareAdvantage: false,
  eCorrespondenceSummary: {
    ehandbook_correspondence: false,
    emsn_correspondence: false
  }
}

export const defaultAccountSettingsResponse: User = {
  ...defaultBeneficiaryResponse,
  eMsnPreferences: {
    isEmailPreferred: false,
    language: Language.En,
    media: EMsnMedia.Audio
  },
  eHandbookPreferences: {
    isEmailPreferred: false,
    language: Language.En,
    media: EHandbookMedia.CdRom
  },
  email: 'raccoon1900@gmail.com'
}

export const defaultAccountHomeResponse: UserWithFields<'eMsnPreferences'> = {
  ...defaultBeneficiaryResponse,
  hasPartA: true,
  hasPartB: true,
  isImmunosuppressiveDrugCoverage: false,
  isMedicareAdvantage: false
}

export const defaultBeneficiaryCardData: IMedicareCard = {
  mbi: '4YT1TE4NU10',
  firstName: 'Fred',
  middleName: 'Charles',
  lastName: 'Flintstone',
  railroadRetirementBoardBeneficiary: true,
  isImmunosuppressiveDrugCoverage: false,
  partAEffectiveDate: '08/01/2000',
  partBEffectiveDate: '08/01/2000',
  partAEndDate: '',
  partBEndDate: ''
}
